/**
 * @generated SignedSource<<246aece2820b13f49cde0598465fd381>>
 * @relayHash d464c5ce295068d47ccc0dcaf071b79b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cb7f849eb94b1fd84196d828e4039833ab7eb4b4aeb9e90b1cb11c693aac6752

import type { ConcreteRequest } from 'relay-runtime';
export type usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery$variables = Record<PropertyKey, never>;
export type usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery$data = {
  readonly paywallContentToDisable: {
    readonly deactivationIdentifier: string;
    readonly link: string | null;
    readonly title: string | null;
  } | null;
};
export type usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery = {
  response: usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery$data;
  variables: usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "contentType",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaywallContentSingle",
    "kind": "LinkedField",
    "name": "paywallContentToDisable",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "deactivationIdentifier"
      },
      {
        "kind": "ScalarField",
        "name": "link"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ],
    "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d464c5ce295068d47ccc0dcaf071b79b",
    "id": "cb7f849eb94b1fd84196d828e4039833ab7eb4b4aeb9e90b1cb11c693aac6752",
    "metadata": {},
    "name": "usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery",
    "operationKind": "query",
    "text": "query usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
  }
};
})();

(node as any).hash = "0ae29c21d88d7354f7898f5999535995";

export default node;
